module.exports = __webpack_public_path__ + "assets-cabinet/img/cal-arrow-left.0e932680.svg";